import { motion } from 'framer-motion';
import { useState, useEffect } from 'react';

const GlitchText = ({ children, className = "" }) => {
  const [isGlitching, setIsGlitching] = useState(false);

  useEffect(() => {
    const triggerGlitch = () => {
      setIsGlitching(true);
      setTimeout(() => {
        setIsGlitching(false);
        // Schedule next glitch in 6-7 seconds
        const nextDelay = Math.random() * 1000 + 6000; // 6-7 seconds
        setTimeout(triggerGlitch, nextDelay);
      }, 300); // Glitch duration
    };

    // Initial delay before first glitch (6-7 seconds)
    const initialDelay = Math.random() * 1000 + 6000;
    const timeoutId = setTimeout(triggerGlitch, initialDelay);

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <motion.span
      className={`${isGlitching ? 'glitch-active' : ''} ${className}`}
      whileHover={{ scale: 1.02 }}
      transition={{ duration: 0.2 }}
      style={{
        display: 'inline-block',
      }}
    >
      {children}
    </motion.span>
  );
};

export default GlitchText;
